<template>
  <!-- Kontener filtrowania zakresowego: elastyczny układ w wierszu -->
  <div class="filter">
    <!-- Etykieta (nazwa) pola, pochodzi z props name -->
    <div class="name">{{ name }}</div>
    <!-- Symbol oznaczający początek zakresu (np. "od") -->
    <span class="symbol">{{ symbolFrom }}</span>
    <!-- Pole input dla wartości początkowej zakresu -->
    <input
      :name="fieldFromName"
      v-model.lazy="valueFrom"
      type="number"
      @wheel.prevent
      @touchmove.prevent
      @scroll.prevent
    />
    <!-- Symbol oznaczający koniec zakresu (np. "do") -->
    <span class="symbol">{{ symbolTo }}</span>
    <!-- Pole input dla wartości końcowej zakresu -->
    <input
      :name="fieldToName"
      v-model.lazy="valueTo"
      type="number"
    />
  </div>
</template>

<script>
import { watch, ref } from "vue";                             // Import funkcji reaktywnych
import { useArchivalFiltersStore } from "../../stores/archivalFilters"; // Store Pinia dla filtrów archiwalnych

export default {
  name: "RangeFilter",                                       // Nazwa komponentu
  props: ["name", "symbolFrom", "fieldFromName", "symbolTo", "fieldToName"],
  
  setup(props) {
    // Inicjalizacja store'a z filtrami
    const filtersStore = useArchivalFiltersStore();

    // Ustawienie początkowych wartości pola od i do na podstawie store'a
    const valueFrom = ref(
      filtersStore.filters[props.fieldFromName] ?? ""
    );
    const valueTo = ref(
      filtersStore.filters[props.fieldToName] ?? ""
    );

    // Funkcja zapisująca zmiany w store: nazwa pola i wartość
    const saveValue = (fieldName, newVal) => {
      filtersStore.addItem(fieldName, newVal);
    };

    // Obserwator zmian obu wartości: valueFrom i valueTo
    watch(
      [valueFrom, valueTo],
      ([newFrom, newTo], [oldFrom, oldTo]) => {
        // Jeśli zmieniła się wartość początkowa, zapisujemy ją
        if (newFrom !== oldFrom) {
          saveValue(props.fieldFromName, newFrom);
        }
        // Jeśli zmieniła się wartość końcowa, zapisujemy ją
        if (newTo !== oldTo) {
          saveValue(props.fieldToName, newTo);
        }
      }
    );

    // Zwracamy referencje do template
    return { valueFrom, valueTo, filtersStore };
  }
};
</script>

<style scoped>
/* Wiersz filtra zakresowego: etykieta — [od] pole — [do] pole.
   Wiersz wpina się w siatkę kolumn `.vehicle-half--grid` (ArchivalVehicleData.vue)
   przez `subgrid`, więc etykieta, oba operatory i oba pola stoją w tych samych
   kolumnach co w pozostałych wierszach formularza — także w wierszu filtra
   pojedynczego, marki/modelu i checkboxów. Odstępy kolumn dziedziczymy z rodzica. */
.filter {
  display: grid;
  grid-column: 1 / -1;
  grid-template-columns: subgrid;
  align-items: center;
  min-width: 0;
  padding: var(--spacing-sm) 0;
  border-bottom: 1px solid var(--border-subtle);
}

/* Usunięcie dolnej ramki dla ostatniego filtra */
.filter:last-child {
  border-bottom: 0;
}

/* Bez własnej szerokości — wyznacza ją wspólna kolumna siatki, więc „Od"
   i „Do" zajmują tyle samo miejsca niezależnie od tłumaczenia. */
.symbol {
  text-align: center;
  font-size: var(--font-size-xs);
  color: var(--text-muted);
  text-transform: lowercase;
}

input {
  width: auto;
  min-width: 0;
  text-align: center;
}
</style>
